<template>
  <div
    class="cart-remove"
    :class="{
      'header-trash': !!header,
    }">
    <button class="" type="button" @click.prevent="removeFromCart(itemIndex)">
      <i class="fa-solid fa-trash"></i>
    </button>
  </div>
</template>

<script lang="ts" setup>
import { useCartStore } from '~/store/cart'
import isValidResponse from '~/utils/isValidResponse'
import { useLanguageStore } from '~/store/language'
import type { CartRemoveResponseInterface } from '~/types/cart/cartBackendTypes'
import { fetchRetryParameters, requestHostHeaders, type RequestHostHeadersType } from '~/composables/constants/api'

const { itemIndex } = defineProps<{
  itemIndex: number
  header?: boolean
}>()

const cartStore = useCartStore()

async function removeFromCart(idx: number) {
  await remove(idx)
}

async function remove(idx: number) {
  const formData = {
    item_id: cartStore.items[itemIndex].id,
    language_id: useLanguageStore().getLanguageId,
  }

  const response = await $fetch<CartRemoveResponseInterface>('/api/cart/remove', {
    method: 'POST',
    body: formData,
    ...fetchRetryParameters,
    retry: 2,
    headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
  })

  if (isValidResponse(response)) {
    cartStore.remove(idx)
  }

  await cartStore.fetch()
}
</script>

<style lang="postcss" scoped>
.cart-remove {
  @apply ml-auto flex items-center justify-center;

  button {
    @apply w-10 h-10 text-lg text-neutral3 hover:text-text1 dark:text-dmText2 transition dark:hover:text-brand-primary;
  }
}

.alt {
  .cart-remove {
    button {
      @apply rounded-md bg-neutral7 hover:bg-neutral5;
    }

    &.header-trash {
      button {
        @apply !bg-transparent hover:!bg-transparent;
      }
    }
  }
}

.wl {
  .cart-remove button {
    @apply bg-white;
  }
}
</style>
